module.exports = {"name":"admin_assist","parameters":[{"name":"hide_conversational_assistant","value":[]}]}